import React from 'react';
import { css } from 'emotion';

import JsonLD from 'site-react/core/helpers/jsonLD';
import theme from 'site-react/theme';

import { helpData } from './FooterSchemaData';

import {
  footerContentPadding,
  footerRegularTextStyle,
  footerLinkStyle,
} from './Footer.styles';

const helpSpanStyles = css`
  ${footerRegularTextStyle};
  margin-bottom: ${theme.spacing.base * 2}px;
`;

const FooterHelpBlock = () => (
  <div className={footerContentPadding}>
    <JsonLD data={helpData} />
    <span className={helpSpanStyles}>Want help?</span>
    <span className={helpSpanStyles}>
      Call us:{' '}
      <a href="tel:+442036080215" className={footerLinkStyle}>
        +44 20 3608 0215
      </a>
    </span>
    <span className={helpSpanStyles}>
      Email:{' '}
      <a
        href="mailto:advisors@hubblehq.com?subject=#Ref 600 - New Inquiry"
        className={footerLinkStyle}
      >
        advisors@hubblehq.com
      </a>
    </span>
  </div>
);

export default FooterHelpBlock;
